import {
  IonCard,
  IonCardContent,
  IonCol,
  IonIcon,
  IonItem,
  IonRow,
  IonSearchbar,
  IonText,
} from "@ionic/react";
import { months } from "./variables";

import { peopleOutline, timeOutline } from "ionicons/icons";

import { useEffect, useState } from "react";
import {
  makeDELETERequest,
  makeGETRequest,
  makePOSTRequest,
} from "../../request/rawRequest";
import { getCurrentTechnoOrDisconnect } from "../../variables/jobDictionnary";
import BasicPage from "../BasicPage/BasicPage";
import { Event } from "../Video/VideoReplay";
import "../generalCSS/stylesheet.css";
import "./NextLives.css";

type LivePresence = {
  present: boolean;
  nb_present: number;
};

type HashMapLive = {
  _id_live: string;
  presences: LivePresence;
};

interface ContainerProps {}

interface LiveDisplayProps {
  live: Event[];
  infoLives: HashMapLive[];
}

const NextLivesDisplay: React.FC<LiveDisplayProps> = ({ live, infoLives }) => {
  const [searchText, setSearchText] = useState<string>("");
  const [liveSearch, setLiveSearch] = useState<Event[]>(live);

  useEffect(() => {
    if (searchText.length <= 0) {
      setLiveSearch(live);
    } else {
      setLiveSearch(
        live.filter((r: any) =>
          r.title
            .toLowerCase()
            .replaceAll(" ", "")
            .includes(searchText.toLowerCase().replaceAll(" ", ""))
        )
      );
    }
  }, [searchText]);

  useEffect(() => {
    setLiveSearch(live);
  }, [live]);

  return (
    <IonRow>
      <IonCol className="border-radius">
        <IonRow>
          <IonCol className="ion-justify-content-center">
            <IonSearchbar
              value={searchText}
              onIonChange={(e) => {
                setSearchText(e.detail.value!);
              }}
              animated
              placeholder="Recherche d'un replay"
            ></IonSearchbar>
          </IonCol>
        </IonRow>
        {liveSearch.length === 0 && searchText.length > 0 && (
          <IonRow>
            <IonCol className="ion-justify-content-center flex">
              <IonText color="black">Aucun live n'a ce titre</IonText>
            </IonCol>
          </IonRow>
        )}
        {liveSearch.length === 0 && searchText.length === 0 && (
          <IonRow>
            <IonCol className="ion-justify-content-center flex">
              <IonText color="black">Aucun live pour le moment</IonText>
            </IonCol>
          </IonRow>
        )}
        {liveSearch.map((live, i) => {
          return (
            <IonCard
              key={i}
              color="light"
              className="card border-radius card-live border-primary-contrast"
            >
              <IonCardContent>
                <IonRow className="live-row">
                  <IonCol>
                    <IonRow>
                      <p className="live-title black-text bold">{live.title}</p>
                    </IonRow>
                    <IonRow>
                      <p className="live-host">par {live.host}</p>
                    </IonRow>
                  </IonCol>
                  <IonCol
                    size="3"
                    size-lg="2"
                    size-sm="3"
                    class="day-number-container"
                  >
                    <IonRow className="ion-justify-content-center bold day-number">
                      {new Date(live.date).getDate()}
                    </IonRow>
                    <IonRow className="ion-justify-content-center">
                      {months[new Date(live.date).getMonth()]}
                    </IonRow>
                  </IonCol>
                </IonRow>
                <IonRow className="live-row">
                  <IonCol size="12" size-lg="12">
                    <IonItem className="item-live">
                      <IonIcon
                        icon={timeOutline}
                        className="live-hours-icon"
                      ></IonIcon>
                      {new Date(live.date).getHours()}h
                      {new Date(live.date).getMinutes()}
                    </IonItem>
                    <IonItem className="item-live">
                      <p>{live.subject}</p>
                    </IonItem>
                  </IonCol>
                </IonRow>
                <IonRow className="live-row">
                  <IonItem className="item-live">
                    <IonIcon
                      icon={peopleOutline}
                      className="live-hours-icon"
                    ></IonIcon>
                    Il y a {infoLives[i]?.presences.nb_present} participants.
                  </IonItem>
                </IonRow>
                {infoLives && infoLives[i] && (
                  <>
                    <IonRow>
                      <IonCol>
                        {infoLives[i]?.presences.present === true ? (
                          <div
                            className="btn"
                            onClick={async () =>
                              await makeDELETERequest("/presence", {
                                id_event: live._id,
                              }).then(() => window.location.reload())
                            }
                          >
                            <IonText color="white">
                              Je ne participe plus
                            </IonText>
                          </div>
                        ) : (
                          <div
                            className="btn"
                            onClick={async () =>
                              await makePOSTRequest("/presence", {
                                id_event: live._id,
                              }).then(() => window.location.reload())
                            }
                          >
                            <IonText color="white">Je participe</IonText>
                          </div>
                        )}
                      </IonCol>
                    </IonRow>
                    <IonRow>
                      <IonCol>
                        <div
                          className="btn"
                          onClick={() =>
                            window.open(live.link, "_blank", "noreferrer")
                          }
                        >
                          <IonText color="white">Je me connecte</IonText>
                        </div>
                      </IonCol>
                    </IonRow>
                  </>
                )}
              </IonCardContent>
            </IonCard>
          );
        })}
      </IonCol>
    </IonRow>
  );
};

const NextLives: React.FC<ContainerProps> = () => {
  const [live, setLive] = useState<Event[]>([]);
  const [infoLive, setInfoLive] = useState<HashMapLive[]>([]);

  const fetchLive = async () => {
    await makeGETRequest(
      "/event/subject?type=live&subject=" + getCurrentTechnoOrDisconnect()
    ).then((response) => {
      setLive([]);
      for (let i = 0; i < response.length; i++) {
        setLive((old) => [...old, { ...response[i] }]);
      }
    });
  };

  useEffect(() => {
    if (live.length > 0) {
      const livesDetails: HashMapLive[] = [];
      makeGETRequest("/me").then((res) => {
        for (const liveItem of live) {
          const liveDetailForOneItem: HashMapLive = {
            _id_live: "",
            presences: {
              present: false,
              nb_present: 0,
            },
          };
          makeGETRequest("/presence/event?id_event=" + liveItem._id).then(
            (response) => {
              const live2: LivePresence = {
                present: false,
                nb_present: 0,
              };
              for (const user of response) {
                if (user.email === res.email) {
                  live2.present = true;
                }
              }
              live2.nb_present = response.length;
              liveDetailForOneItem._id_live = liveItem._id;
              liveDetailForOneItem.presences = live2;
              livesDetails.push(liveDetailForOneItem);
              setInfoLive((old) => [...old, liveDetailForOneItem]);
            }
          );
        }
      });
    }
  }, [live]);

  useEffect(() => {
    fetchLive();
  }, []);

  return (
    <BasicPage
      pathReturn
      title="Live"
      subtitle="Afin d’améliorer votre apprentissage,vous pourrez participer à des cours en direct proposés par nos experts"
    >
      <NextLivesDisplay live={live} infoLives={infoLive} />
    </BasicPage>
  );
};

export default NextLives;
